import React from "react";
import { useTranslation } from "react-i18next";
import { useSnapshot } from "valtio";

import {
    PrinterRowData,
    PrinterSetting as SharedPrinterSetting,
} from "@components/Common/PrinterSetting";

import { store as languageStore } from "@pages/SettingGeneral/Language/store";
import {
    store as settingPrinter,
    setIsSettingModalOpened,
    setIsSettingFromPrinter,
} from "./store";
import { setIsConfigurationPrinterClicked } from "../../Applications/Kiosk/store";

import { buildPeripheralsPrinterSettingConfig } from "./peripheralsPrinterSettingConfig";

type PrinterSettingSharedProps = {
    oneShop?: boolean;
    setDataIsUpdated: (value: boolean | number) => void;
};

export default function PrinterSettingShared({
    oneShop = false,
    setDataIsUpdated,
}: PrinterSettingSharedProps) {
    const { t } = useTranslation();
    const { isSettingModalOpened } = useSnapshot(settingPrinter);
    const { shopRowData } = useSnapshot(languageStore);
    const config = React.useMemo(
        () => buildPeripheralsPrinterSettingConfig(t),
        [t]
    );

    const handleClose = () => {
        setIsSettingFromPrinter(false);
        setIsConfigurationPrinterClicked(false);
        setIsSettingModalOpened(false);
    };

    return (
        <SharedPrinterSetting
            isOpen={isSettingModalOpened}
            onClose={handleClose}
            rowData={(shopRowData as unknown) as PrinterRowData}
            oneShop={oneShop}
            config={config}
            onSaved={() => setDataIsUpdated(true)}
        />
    );
}
